import {snakeCase} from 'change-case';
import {europeanCountries} from '@ace-de/eua-entity-types';
import serviceManager from '../serviceManager';

const parseGoogleAddress = async (value, translate, isReverseGeolocation = false) => {
    const googleMapsService = serviceManager.loadService('googleMapsService');
    let parsedAddress = null;
    const googleMapsServiceMethod = isReverseGeolocation
        ? googleMapsService.getAddressFromGeolocation
        : googleMapsService.getGeolocationFromString;
    await googleMapsServiceMethod(value).then(result => {
        if (result && result.address) {
            const country = result.address.countryCode
                ? europeanCountries[result.address.countryCode]?.name
                : '';

            parsedAddress = {
                street: result.address.street || '',
                postCode: result.address.postCode,
                city: result.address.city,
                country: country ? translate(`global.country.${snakeCase(country)}`) : '',
                countryCode: result.address.countryCode,
                formattedAddress: [result.address.street,
                    result.address.postCode,
                    result.address.city,
                    country ? translate(`global.country.${snakeCase(country)}`) : ''].filter(Boolean).join(', '),
                longitude: result.location?.lng,
                latitude: result.location?.lat,
                id: result.id,
            };
        }
    });
    return parsedAddress;
};

export default parseGoogleAddress;

